import { PASSWORD_VALIDATOR } from '@constants';
import { ValidationResult } from 'hooks';

export const validatePassword = (password: string): ValidationResult => {
  const result = {
    isValid: true,
    error: ''
  };

  const isValid = PASSWORD_VALIDATOR.test(String(password));
  if (!isValid) {
    result.error = 'Should be 8-20 characters long, contain upper and lower case characters, numbers, special characters';
    result.isValid = false;
  }

  return result;
};
